export const GOOGLE_RECAPTCHA_SITE_KEY =
  process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

const DEFAULT_RECAPTHCA_ENV_VALUE = '#{NEXT_PUBLIC_RECAPTCHA_SITE_KEY}#';

export const hasCaptchaSiteKey = () => {
  if (GOOGLE_RECAPTCHA_SITE_KEY) {
    if (GOOGLE_RECAPTCHA_SITE_KEY === DEFAULT_RECAPTHCA_ENV_VALUE) return false;
    return true;
  } else return false;
};
